/**
 * `modules/actionHandler.js`
 * - UI 操作（画像切り替え、開閉アニメーションなど）を統一管理
 *
 * 使用方法:
 * - import {initActionHandlers} from "../modules/actionHandler.js";
 * - initActionHandlers();
 */


import {barbaEventObserver} from "../core/barba/utils/barbaEventObserver.js";
import {getContainer} from "../utils/index.js";
import {initSwitcher} from "./action/switcher.js";
import {initDropdown} from "./action/dropdown.js";
import {initSubmenu} from "./action/submenu.js";
import {initScrollTop} from "./action/scrollTop.js";
import {initModal, initSearchModal, initVimeoModal, initYouTubeModal} from "./action/modal.js";


export function initActionHandlers(data = null) {
  const listeners = [];
  const container = getContainer(data);
  if (!container) return;

  const elements = [...container.querySelectorAll("[data-action]")];

  // ヘッダーなどBarba領域外の要素も対象にする
  if (container !== document) {
    // すでに container に含まれるものと重複しないよう、document から追加する形にする
    document.querySelectorAll("[data-action]").forEach((el) => {
      if (!elements.includes(el)) {
        elements.push(el);
      }
    });
  }

  elements.forEach((element) => {
    const actionType = element.dataset.action;

    switch (actionType) {
      case "switcher":
        initSwitcher(element, container, listeners);
        break;

      case "dropdown":
        initDropdown(element, listeners, 400);
        break;

      case "submenu":
        initSubmenu(element, listeners);
        break;

      case "scrollTop":
        initScrollTop(element, listeners);
        break;

      case "modal":
        initModal(element, container, listeners);
        break;

      case "searchModal":
        initSearchModal(element, container, listeners);
        break;

      case "youtubeModal":
        initYouTubeModal(element, container, listeners);
        break;

      case "vimeoModal":
        initVimeoModal(element, container, listeners);
        break;

      default:
        console.warn(`⚠️ 未知のアクションタイプ: ${actionType}`);
        break;
    }
  });

  barbaEventObserver.observeEvents(listeners);
}
